/**
 * @param {{title:String|null,text:String|null,socials:Array|null,className:String|null}} par
 * @return {mkE.Base|Node|null}
 * @constructor
 */
T.SocialIcons = function(par = {}) {
	if (typeof par.title === 'undefined') {
		par.title = D.Lang.get('home.socials.title');
	}
	if (typeof par.text === 'undefined') {
		par.text = D.Lang.get('home.socials.text');
	}
	if (typeof par.socials === 'undefined') {
		par.socials = [
			'fb',
			'ig',
			'tk',
			'yt',
			'in'
		];
	}
	let className = 'social-icons';
	if (typeof par.className !== 'undefined') {
		className += ' ' + par.className;
	}
	let els = [];
	for (let i = 0; i < par.socials.length; i++) {
		const social = par.socials[i];
		els.push({
			tag: 'a',
			target: '_blank',
			className: 'social-icon social-icon-' + social,
			attr: {
				rel: 'nofollow'
			},
			href: D.Lang.get(`socials.${social}.url`),
			els: [
				{
					tag: 'span',
					text: D.Lang.get(`socials.${social}.name`)
				}
			]
		});
	}
	return mkE({
		tag: 'div',
		className: className,
		els: [
			par.title ? {
				tag: 'div',
				className: 'h2',
				text: par.title
			} : '',
			par.text ? {
				tag: 'p',
				text: par.text
			} : '',
			{
				tag: 'div',
				className: 'icons',
				els: els
			}
		]
	});
};